import React from "react";
import { CondenserIcon } from "@icons/hexpert/HEXCondenserIcon";
import { HeaterCoolerIcon } from "@icons/hexpert/HEXHeaterCooler";
import { VaporizerIcon } from "@icons/hexpert/HEXVaporizerIcon";
import cs from "classnames";
import { FormType } from "../../../types/hexpertTypes";
import './EntryButton.scss';

type EntryButtonProps = {
  icon?: FormType;
  label?: string;
  action?: () => void;
  fixedWidth?: boolean;
};

const getIcon = (icon: FormType) => {
  switch (icon) {
    case FormType.CONDENSER:
      return <CondenserIcon />;
    case FormType.HEATCOOL:
      return <HeaterCoolerIcon />;
    case FormType.VAPORIZER:
      return <VaporizerIcon />;
  }
};

export const EntryButton = ({ icon, label, action, fixedWidth }: EntryButtonProps) => {
  return (
    <button
      className={cs("c-hex-entry-button", {
        [`c-hex-entry-button-fixed`]: fixedWidth,
      })}
      onClick={action}
    >
      {getIcon(icon)}
      <h3 className="c-hex-entry-button-heading">{label}</h3>
    </button>
  );
};
